module.exports = __webpack_public_path__ + "static/media/marie_cropped.10040960.png";